module.exports = __webpack_public_path__ + "img/logo_conquer.f6cc0dc9.png";